// loginLink.mjs — 第八十七批：提醒信里那枚次抛登录链接的落地页纯逻辑。
//
// 页面本身只有三种状态（兑现中／失败／已进站），逻辑全在这里，故可脱离浏览器测。
//
// ── 为什么落地页要"先 GET 再 POST" ──────────────────────────────────────────
// 链接躺在邮件里，而企业邮关、Outlook Safe Links 与各种预取器会**先替收信人 GET
// 一遍每条链接**。若 GET 即消费，这枚一次性令牌会在收信人点开之前就被扫描器烧掉，
// 他看到的将是"链接无效"——而这个失败对我方完全不可见（日志里只有一次正常登录）。
// 所以 GET 只取回 SPA，真正的消费是本页发出的那一枚 POST。

// URL 查询串里的令牌。`?t=` 是唯一形式（信里的链接由后端拼，见 core/reminder.cpp）。
// 取不到（缺参、空值、只有 `?t`）一律给空串——调用方据此直接显示失败，
// 而不是拿一个空令牌去请求一次注定 401 的登录。
export function tokenFromSearch(search) {
  const s = String(search ?? '');
  const qs = s.startsWith('?') ? s.slice(1) : s;
  for (const pair of qs.split('&')) {
    if (!pair) continue;
    const eq = pair.indexOf('=');
    if (eq === -1) continue;                       // `?t`（无等号）不算给了令牌
    if (pair.slice(0, eq) !== 't') continue;
    const raw = pair.slice(eq + 1);
    try {
      return decodeURIComponent(raw).trim();
    } catch {
      return raw.trim();                           // 畸形转义：原样交给后端去判
    }
  }
  return '';
}

// 登录成功后要落到哪里。默认首页；`next` 仅接受**站内绝对路径**。
// 拒绝 `//evil.com` 与带 scheme 的值：一个能把访问者送去任意站点的参数，配上一封
// 我方发出的邮件，就是一个以我方域名背书的跳板。这里不做白名单，只做形状判断——
// 站内路径必然以单个 `/` 开头。
export function safeNext(next) {
  const v = String(next ?? '');
  if (!v.startsWith('/')) return '/';
  if (v.startsWith('//')) return '/';
  return v;
}

// 后端回执 → 页面状态。失败一律同一句文案（后端本就只回一种 INVALID_LINK，
// 四种失效原因不外泄；前端再分岔就是替后端把那道纪律拆了）。
export function linkOutcome({ ok, status }) {
  if (ok) return 'signedIn';
  if (status === 401) return 'invalid';
  return 'error';        // 网络/5xx：可以重试，与"链接已废"不是一回事
}
